import React, { Component } from 'react';
import _ from 'lodash';
import HomeView from './HomeView';

export default class Home extends Component {
  render() {
    const pages = _(this.props.userPages)
      .sortBy('order')
      .filter('onHomePage')
      .filter(page => page.link || page.key) // required for jump
      .value();
    return (<HomeView
      history={this.props.history}
      pages={pages}
    />);
  }
}
